import axios from "axios";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";
import { MethodCalculation } from "../../types/model/calculation";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/calculations/captures`;

export const getCalculationByCaptureId = async (
  captureId: number,
  method: string,
): Promise<MethodCalculation[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<MethodCalculation[]>(`${BASE_URL}/${captureId}`, {
    params: {
      method,
    },
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};
